namespace GeniuzPOS.PriceChange {
    export interface AddPriceChangeRow {
        Id?: number;
        EffectiveDate?: string;
        PluCode?: string;
        PluName?: string;
        SellUnitPrice1Fg?: boolean;
        SellUnitPrice2Fg?: boolean;
        SellUnitPrice3Fg?: boolean;
        SellUnitPrice4Fg?: boolean;
        SellUnitPrice5Fg?: boolean;
        SellUnitPrice6Fg?: boolean;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        ApproveFg?: ApproveFgSelect;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace AddPriceChangeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'PriceChange.AddPriceChange';
        export const lookupKey = 'PriceChange.AddPriceChange';

        export function getLookup(): Q.Lookup<AddPriceChangeRow> {
            return Q.getLookup<AddPriceChangeRow>('PriceChange.AddPriceChange');
        }
        export const deletePermission = '1POSBASE:การเปลี่ยนราคาขาย:กำหนดราคา:Delete';
        export const insertPermission = '1POSBASE:การเปลี่ยนราคาขาย:กำหนดราคา:Modify';
        export const readPermission = '1POSBASE:การเปลี่ยนราคาขาย:กำหนดราคา:View';
        export const updatePermission = '1POSBASE:การเปลี่ยนราคาขาย:กำหนดราคา:Modify';

        export declare const enum Fields {
            Id = "Id",
            EffectiveDate = "EffectiveDate",
            PluCode = "PluCode",
            PluName = "PluName",
            SellUnitPrice1Fg = "SellUnitPrice1Fg",
            SellUnitPrice2Fg = "SellUnitPrice2Fg",
            SellUnitPrice3Fg = "SellUnitPrice3Fg",
            SellUnitPrice4Fg = "SellUnitPrice4Fg",
            SellUnitPrice5Fg = "SellUnitPrice5Fg",
            SellUnitPrice6Fg = "SellUnitPrice6Fg",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            ApproveFg = "ApproveFg",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
